import { localizedText, getLocale } from '../../common-js/LanguageMap';

export default function ($scope, $state, $log, $timeout, $filter, addonFactory, DrawpService) {
    $scope.localizedText = localizedText;
    $scope.localizedTextSuffix = getLocale() === 'es' ? '_es' : '';

    $scope.stateTitle = $scope.localizedText('FILL_IN_THE_BLANK_FRAMES');
    $scope.stateSubtitle = $scope.localizedText('6_LEVELS');
    $scope.backState = 'addonAppIndex';
    $scope.stateClass = 'fitb6-item';
    $scope.toolId = '6603b1a1e4b0f12b1a345681';

    $scope.slideDialogData = {
        type: '',
        value: '',
    };

    // let serverUrl = 'https://app.drawpforschool.com/';
    // let presentationId;

    $scope.error = null;
    const progressText = $scope.localizedText('LOADING');
    $scope.progress = progressText;
    $scope.enableReload = true;

    const ERROR_MESSAGE = addonFactory.API_CALL_ERROR.GENERICERROR;

    let elemInputSearch = null;
    let elemLanguageProficiency = null;
    $scope.elemBloomsLevel = null;
    let elemSelectpairs = null;

    let alertDialog = null;
    let subscriptionInfoDialog = null;
    let elementCancelSub = null;
    let insertTextDebounce = false;

    $scope.isSearchFilteringRunning = false;
    $scope.name_of_the_tool = '';
    $scope.userEmail = '';
    $scope.serverToken = '';
    $scope.language = 'en';
    $scope.selectpairs = true;
    $scope.enable_language_element = false;
    $scope.subscription_days = 100;
    $scope.subscription = null;
    $scope.alert_multi_account = false;
    $scope.loginDialogMessage = '';
    $scope.isLoginDialogOpen = false;

    $scope.bundle_id = '';
    $scope.questions_id = '';
    $scope.sentence_frame_id = '';
    $scope.formData = null;
    $scope.disabledFeature = true;
    $scope.currentContent = [];

    $scope.currentQueryData = {
        dok: '',
        langProf: '',
        elaEldStandard: ''
    };

    $scope.searchData = null;
    $scope.searchQuery = '';
    $scope.searchErrorMessage = '';
    $scope.searchResultsQuestionIds = [];
    $scope.searchResultsSentenceIds = [];

    $scope.currentQuestionSet = null;
    $scope.currentSentenceSet = null;

    $scope.isNavCollapseableHidden = false;
    $scope.isQuestionListActive = true;
    $scope.isProductStrategyCollapsed = false;

    $scope.unSortedDokList = [];
    $scope.disabledDokList = [];
    $scope.unSortedLangProfList = [];
    $scope.unSortedELAELDStandardsList = [];

    $scope.questionList = [];
    $scope.sentenceList = [];

    $scope.language_strategy = '';
    $scope.language_function = '';

    const levelStrategy = {
        '600045776180724bcf6c3c01': 'Teacher and students engage with Think-Pair-Share; 5-WH Questions; W-K-W-L; cognates; Language Experience Approach; interactive journals; predictable text; primary text; and graphic organizers.',
        '600045776180724bcf6c3c02': 'Teacher and students engage with highlighting text; Question author’s purpose; T-chart; translate text to primary language; T.P.R.; use multi-leveled texts; Word/Concept Walls; audio support; Personal Diary; and paraphrasing.',
        '600045776180724bcf6c3c03': 'Teachers and students engage with interviews; role-playing; Found Poems; a personal dictionary; Collaborative discussion; use of highlighters, step-by-step literary analysis; questioning vocabulary and concepts; vocabulary cards; and daily writing.',
        '600045776180724bcf6c3c04': 'Teachers and students engage with Preview-review; Timeline; Venn Diagram; T-note taking with unfamiliar concepts; Sequence; Paraphrase; and PowerPoint of text analysis.',
        '600045776180724bcf6c3c05': 'Teachers and students engage with think-aloud of unpacking language and functions; Note-taking; Journal entries; Venn Diagram; Debates; Anticipation Guide; Self-evaluation; and Partner reading.',
        '600045776180724bcf6c3c06': 'Teacher and students engage with models; interpretations into a new art form; graphic organizers for new information; role-play; scripts created with examples; theater performances; extending learning with PowerPoints, websites, and podcasts; and original poetry/music.',
    };

    const levelFunction = {
        '600045776180724bcf6c3c01': 'Students are to identify, illustrate, copy, retell, describe, label, listen, name, state, match, organize, observe, sequence, recognize, and list.',
        '600045776180724bcf6c3c02': 'Students are asked to explain, classify, compare, discuss, demonstrate, indicate, restate, select, group, show, differentiate, convert, interpret, paraphrase, summarize, distinguish, express, translate, cite, generalize, review, rewrite.',
        '600045776180724bcf6c3c03': 'Students are asked to demonstrate, apply, construct, use, resolve, report, teach, act, chart, examine, explain, record, relate, complete, interpret, develop, write and infer.',
        '600045776180724bcf6c3c04': 'Students are asked to analyze, separate, explain, select, connect, conclude, diagram, organize, question, correlate, criticize, deduce, infer, prioritize, survey, and outline.',
        '600045776180724bcf6c3c05': 'Students are asked to evaluate, discriminate, summarize, support with evidence, choose, rate, consider, distinguish, test, reframe, assess, convince, argue, defend, rank, conclude, debate, persuade, and justify.',
        '600045776180724bcf6c3c06': 'Students are asked to design, create, plan, combine, construct, develop, rewrite, express, rearrange, compose, invent, hypothesize, re-organize, interpret, modify, imagine, originate, validate, and adapt.',
    };

    $scope.onNavToggle = () => {
        $scope.isNavCollapseableHidden = !$scope.isNavCollapseableHidden;
    };

    $scope.onQuestionToggle = () => {
        $scope.isQuestionListActive = !$scope.isQuestionListActive;
    };

    const showProgress = (show, message) => {
        $timeout(() => {
            $scope.error = null;
            $scope.progress = null;
            if (show) {
                $scope.progress = message;
            }
        });
    };

    const showError = (show, message) => {
        $timeout(() => {
            $scope.error = null;
            $scope.progress = null;
            if (show) {
                $scope.error = message;

                if (message === addonFactory.API_CALL_ERROR.QUOTAERROR) {
                    $scope.enableReload = false;
                } else {
                    $scope.enableReload = true;
                }
            }
        });
    };

    const errorHandler = (error) => {
        const errorResp = addonFactory.errorHandler(error, $scope);
        showError(true, errorResp);
    };

    const setDOK = (data) => {
        $timeout(() => {
            $scope.unSortedDokList = [];

            const newDokList = angular.copy(data.dropdown_values);

            $scope.keysDok = Object.values(newDokList);
            $scope.keysDok = $filter('orderBy')($scope.keysDok, '-order', false);
            $scope.unSortedDokList = $scope.keysDok;
        });
    };

    const setLanguageProficiency = (data) => {
        $timeout(() => {
            $scope.unSortedLangProfList = [];

            const newLangProfList = angular.copy(data.dropdown_values);

            $scope.keysLangProf = Object.values(newLangProfList);
            $scope.keysLangProf = $filter('orderBy')($scope.keysLangProf, 'order', false);
            $scope.unSortedLangProfList = $scope.keysLangProf;
        });
    };

    const setQuestionSection = () => {
        $timeout(() => {
            $scope.questionList = [];
            angular.forEach($scope.currentContent, (value) => {
                $scope.questionList.push(value.question);
            });

            if ($scope.searchData != null) {
                const filteredDok = $scope.searchData[$scope.currentQueryData.dok];
                const filteredLangProf = filteredDok[$scope.currentQueryData.langProf];
                $scope.searchResultsQuestionIds = filteredLangProf;
            }
        });
    };

    const setSentenceSection = () => {
        $timeout(() => {
            $scope.sentenceList = [];
            angular.forEach($scope.currentContent, (value) => {
                angular.forEach(value.sentences, (val) => {
                    $scope.sentenceList.push(val);
                });
            });

            if ($scope.searchData) {
                const filteredDok = $scope.searchData[$scope.currentQueryData.dok];
                const filteredLangProf = filteredDok[$scope.currentQueryData.langProf];
                $scope.searchResultsSentenceIds = filteredLangProf;

                let questionSectionHasResults = false;
                let sentenceSectionHasResults = false;
                angular.forEach($scope.questionList, (value) => {
                    if (!questionSectionHasResults) {
                        questionSectionHasResults = $scope.searchResultsQuestionIds.includes(value.id);
                    }
                });

                angular.forEach($scope.sentenceList, (value) => {
                    if (!sentenceSectionHasResults) {
                        sentenceSectionHasResults = $scope.searchResultsSentenceIds.includes(value.id);
                    }
                });


                if ($scope.isQuestionListActive && !questionSectionHasResults) {
                    $scope.isQuestionListActive = false;
                }

                if (!$scope.isQuestionListActive && !sentenceSectionHasResults) {
                    $scope.isQuestionListActive = true;
                }
            }
        });
    };

    const setStategiesFunctionsSection = () => {
        $timeout(() => {
            $scope.language_strategy = levelStrategy[$scope.currentQueryData.dok];
            $scope.language_function = levelFunction[$scope.currentQueryData.dok];
        });
    };

    const loadLessonPlan = () => {

        // Since we are changing the values for the drop down programatically the on change of the drop downs will trigger the 
        // loadLessonPlan method, there might be simiultaneous requests thus to prevent that I have used a isSearchFilteringRunning key to 
        // know when the api call should and should not happen
        if ($scope.isSearchFilteringRunning) {
            return;
        }

        $scope.currentQueryData.dok = $scope.elemBloomsLevel.value;
        $scope.currentQueryData.langProf = elemLanguageProficiency.value;

        const searchTags = [
            $scope.elemBloomsLevel.value,
            elemLanguageProficiency.value
        ];

        DrawpService.getLvl6Content(
            searchTags,
            $scope.language,
            $scope.serverToken
        ).then((response) => {
            const content = response.data;
            $scope.currentContent = content.data;

            setQuestionSection();
            setSentenceSection();
            setStategiesFunctionsSection();

            showProgress(false, '');
        }).catch((error) => {
            $log.info(error);
            errorHandler(error);
        });
    };

    // Drop Down Selected Item
    const selectElement = (value, type) => {
        if (type === 'dok') {
            const index = $scope.unSortedDokList.findIndex(x => x.id === value);
            $scope.elemBloomsLevel.selectedIndex = index;
            $scope.currentQueryData.dok = value;
        }
        else if (type === 'languageProficiency') {
            const index = $scope.unSortedLangProfList.findIndex(x => x.id === value);
            elemLanguageProficiency.selectedIndex = index;
            $scope.currentQueryData.langProf = value;
        }
    };

    const initSelectFieldListeners = () => {
        elemLanguageProficiency = mdc.select.MDCSelect.attachTo(document.querySelector('#language-proficiency'));
        $scope.elemBloomsLevel = mdc.select.MDCSelect.attachTo(document.querySelector('#blooms-level'));

        $scope.elemBloomsLevel.selectedIndex = 0;
        elemLanguageProficiency.selectedIndex = 0;

        elemLanguageProficiency.listen('MDCSelect:change', () => {
            if ($scope.currentQueryData.dok === $scope.elemBloomsLevel.value &&
                $scope.currentQueryData.langProf === elemLanguageProficiency.value) {
                // Do nothing
            } else {
                loadLessonPlan();
            }
        });

        $scope.elemBloomsLevel.listen('MDCSelect:change', () => {
            $scope.$apply();
            const selectedDok = $scope.elemBloomsLevel.value;

            if ($scope.searchData) {
                // check if current dok and ell has results
                const hasCurrentValues = $scope.searchData[selectedDok][$scope.currentQueryData.langProf];

                if (Object.keys(hasCurrentValues).length === 0) {
                    const hasLvl1Values =
                        $scope.searchData[selectedDok]['600045776180724bcf6c3bfa'];
                    const hasLvl2Values =
                        $scope.searchData[selectedDok]['600045776180724bcf6c3bfb'];
                    const hasLvl3Values =
                        $scope.searchData[selectedDok]['600045776180724bcf6c3bfc'];
                    const hasLvl4Values =
                        $scope.searchData[selectedDok]['600045776180724bcf6c3bfd'];
                    const hasLvl5Values =
                        $scope.searchData[selectedDok]['600045776180724bcf6c3bfe'];
                    const hasLvl6Values =
                        $scope.searchData[selectedDok]['600045776180724bcf6c3bff'];

                    if (Object.keys(hasLvl1Values).length > 0) {
                        selectElement('600045776180724bcf6c3bfa', 'languageProficiency');
                    } else if (Object.keys(hasLvl2Values).length > 0) {
                        selectElement('600045776180724bcf6c3bfb', 'languageProficiency');
                    } else if (Object.keys(hasLvl3Values).length > 0) {
                        selectElement('600045776180724bcf6c3bfc', 'languageProficiency');
                    } else if (Object.keys(hasLvl4Values).length > 0) {
                        selectElement('600045776180724bcf6c3bfd', 'languageProficiency');
                    } else if (Object.keys(hasLvl5Values).length > 0) {
                        selectElement('600045776180724bcf6c3bfe', 'languageProficiency');
                    } else if (Object.keys(hasLvl6Values).length > 0) {
                        selectElement('600045776180724bcf6c3bff', 'languageProficiency');
                    }
                }
            }

            if ($scope.currentQueryData.dok === $scope.elemBloomsLevel.value &&
                $scope.currentQueryData.langProf === elemLanguageProficiency.value) {
                // Do nothing
            } else {
                loadLessonPlan();
            }
        });

        if ($scope.subscription_days == null || $scope.subscription_days <= 0) {
            elemInputSearch.disabled = true;
            elemLanguageProficiency.disabled = true;
            $scope.elemBloomsLevel.disabled = true;
        } else {
            elemInputSearch.disabled = false;
            elemLanguageProficiency.disabled = false;
            $scope.elemBloomsLevel.disabled = false;
        }
        loadLessonPlan();
    };

    const getLoginSuccess = () => {
        $scope.initValueLanguage = $scope.formData.defaults.language;
        $scope.initValuePlaceholder = $scope.formData.defaults.placeholder;
        $scope.initValueAudio = $scope.formData.defaults.audio;

        angular.forEach($scope.formData.filters, (value) => {
            if (!value.deleted) {
                if (value.id === '600045776180724bcf6c3c00') {
                    setDOK(value);
                } else if (value.id === '600045776180724bcf6c3bf9') {
                    setLanguageProficiency(value);
                }
            }
        });

        showProgress(false, '');
        $timeout(() => {
            initSelectFieldListeners();
        }, 100);
    };

    const init = () => {
        showProgress(true, progressText);
        DrawpService.getLvl6login($scope.serverToken).then((response) => {
            $scope.formData = response.data;

            $scope.subscription_days = $scope.formData.subscription_expired;
            $scope.subscription = $scope.subscription_days != null && $scope.subscription_days > 0;
            DrawpService.gAPageview('language-scaffolding-tool-6', 'Fill-in-the-Blank Frames', 6, $scope.subscription, $scope.userEmail, $scope.serverToken);

            if (!$scope.subscription) {
                angular.element('#search-popover').popover({
                    container: 'body',
                    placement: 'top',
                    trigger: 'hover',
                    content: 'Not available with your subscription'
                });

                angular.element('#lang-prof-popover').popover({
                    container: 'body',
                    placement: 'top',
                    trigger: 'hover',
                    content: 'Not available with your subscription'
                });

                angular.element('#dok-popover').popover({
                    container: 'body',
                    placement: 'top',
                    trigger: 'hover',
                    content: 'Not available with your subscription'
                });
            } else {
                angular.element('#search-popover').popover('hide');
                angular.element('#lang-prof-popover').popover('hide');
                angular.element('#dok-popover').popover('hide');
            }
            // Avoid completing load if state has changed
            if ($state.current.name !== 'scaffoldingLevel6') return;
            getLoginSuccess();
        }).catch((error) => {
            errorHandler(error);
            // showError(true, 'There was an error while loading this page');
        });
    };

    angular.element(document).ready(() => {

        alertDialog = mdc.dialog.MDCDialog.attachTo(document.querySelector('#alert_dialog'));

        // subscriptionInfoDialog = mdc.dialog.MDCDialog.attachTo(document.querySelector('#subscription_info_dialog'));

        elemInputSearch = mdc.textField.MDCTextField.attachTo(document.querySelector('#search-field'));

        elemSelectpairs = mdc.switchControl.MDCSwitch.attachTo(document.querySelector('#select-pairs-switch'));
        elemSelectpairs.checked = true;

        mdc.list.MDCList.attachTo(document.querySelector('.mdc-list'));

        init();
    });

    const showDialog = (message) => {
        $scope.name_of_the_tool = message;
        alertDialog.open();
    };

    const insertQuestionSet = (type, value, destIndex) => {
        const sentences = [];
        const textBoxIds = [];
        const textBoxDatas = [];

        if (type === 'frame_pair') {
            angular.forEach(value.sentences, (sentence) => {
                sentences.push(decodeURIComponent(sentence.text).trim());
                textBoxIds.push(sentence.id);
                textBoxDatas.push(sentence.text);
            });

            DrawpService.addTextBoxPairToSlide((value.question.text).trim(), sentences).then(() => {
                DrawpService.gATextBoxPairAddEvent(value.question.id, value.question.text, textBoxIds, textBoxDatas, $scope.language, $scope.currentQueryData.dok, $scope.currentQueryData.langProf, $scope.currentQueryData.elaEldStandard, false, null, $scope.initValueLanguage, $scope.initValueAudio, true, 6, $scope.subscription, $scope.serverToken);
            }).catch((error) => {
                $log.info(error);
                errorHandler(error);
            });
        } else {
            DrawpService.addTextBoxToSlide((value.text).trim()).then((res) => {
                DrawpService.gATextBoxAddEvent(type, value.id, value.text, $scope.language, $scope.currentQueryData.dok, $scope.currentQueryData.langProf, $scope.currentQueryData.elaEldStandard, false, null, $scope.initValueLanguage, $scope.initValueAudio, true, 6, $scope.subscription, $scope.serverToken);
            }).catch((error) => {
                $log.info(error);
                errorHandler(error);
            });
        }
    };

    $scope.insertText = (value, type) => {
        const sentences = [];
        const textBoxIds = [];
        const textBoxDatas = [];

        if (!$scope.subscription_days || $scope.subscription_days <= 0) {

            if (insertTextDebounce) {
                return;
            }

            setTimeout(() => {
                insertTextDebounce = false;
            }, 1000);

            insertTextDebounce = true;

            if (type === 'frame_pair') {
                angular.forEach(value.sentences, (sentence) => {
                    sentences.push(decodeURIComponent(sentence.text).trim());
                    textBoxIds.push(sentence.id);
                    textBoxDatas.push(sentence.text);
                });
                DrawpService.gATextBoxPairAddEvent(value.question.id, value.question.text, textBoxIds, textBoxDatas, $scope.language, $scope.currentQueryData.dok, $scope.currentQueryData.langProf, $scope.currentQueryData.elaEldStandard, false, '', $scope.initValueLanguage, $scope.initValueAudio, false, 6, $scope.subscription, $scope.serverToken);
            } else {
                DrawpService.gATextBoxAddEvent(type, value.id, value.text, $scope.language, $scope.currentQueryData.dok, $scope.currentQueryData.langProf, $scope.currentQueryData.elaEldStandard, false, '', $scope.initValueLanguage, $scope.initValueAudio, false, 6, $scope.subscription, $scope.serverToken);
            }

            showDialog('Language Scaffolding Tool (6 levels)');
        } else {
            insertQuestionSet(type, value, 0);
        }
    };

    $scope.searchFunction = () => {

        if ($scope.searchQuery.trim().length === 0) {
            return false;
        }

        showProgress(true, progressText);

        $scope.searchErrorMessage = '';

        let selectedElaEldStandards = $scope.currentQueryData.elaEldStandard;
        if (selectedElaEldStandards === 'all') {
            selectedElaEldStandards = null;
        }

        DrawpService.lvl6Search($scope.searchQuery, selectedElaEldStandards, $scope.language, $scope.serverToken).then((text) => {
            DrawpService.gALangScaffSearchEvent($scope.searchQuery, $scope.language, $scope.initValueLanguage, 6, $scope.subscription, $scope.serverToken);

            const data = text.data;
            $scope.searchData = data.data;

            $scope.searchErrorMessage = '';

            if (!data.result_found) {
                $scope.searchData = null;
                $scope.searchResultsQuestionIds = [];
                $scope.searchResultsSentenceIds = [];

                $scope.searchErrorMessage = 'No results found';
                setQuestionSection();
                setSentenceSection();
                showProgress(false, '', false, false);
            } else {
                $scope.searchErrorMessage = '';
                $scope.isSearchFilteringRunning = true;

                // check if current dok and ell has results

                const hasCurrentValues =
                    $scope.searchData[$scope.currentQueryData.dok][$scope.currentQueryData.langProf];

                if (Object.keys(hasCurrentValues).length === 0) {
                    selectElement(data.result_found.dok, 'dok');

                    const hasLvl1Values =
                        $scope.searchData[data.result_found.dok]['600045776180724bcf6c3bfa'];
                    const hasLvl2Values =
                        $scope.searchData[data.result_found.dok]['600045776180724bcf6c3bfb'];
                    const hasLvl3Values =
                        $scope.searchData[data.result_found.dok]['600045776180724bcf6c3bfc'];
                    const hasLvl4Values =
                        $scope.searchData[data.result_found.dok]['600045776180724bcf6c3bfd'];
                    const hasLvl5Values =
                        $scope.searchData[data.result_found.dok]['600045776180724bcf6c3bfe'];
                    const hasLvl6Values =
                        $scope.searchData[data.result_found.dok]['600045776180724bcf6c3bff'];

                    if (Object.keys(hasLvl1Values).length > 0) {
                        selectElement('600045776180724bcf6c3bfa', 'languageProficiency');
                    } else if (Object.keys(hasLvl2Values).length > 0) {
                        selectElement('600045776180724bcf6c3bfb', 'languageProficiency');
                    } else if (Object.keys(hasLvl3Values).length > 0) {
                        selectElement('600045776180724bcf6c3bfc', 'languageProficiency');
                    } else if (Object.keys(hasLvl4Values).length > 0) {
                        selectElement('600045776180724bcf6c3bfd', 'languageProficiency');
                    } else if (Object.keys(hasLvl5Values).length > 0) {
                        selectElement('600045776180724bcf6c3bfe', 'languageProficiency');
                    } else if (Object.keys(hasLvl6Values).length > 0) {
                        selectElement('600045776180724bcf6c3bff', 'languageProficiency');
                    }
                }

                // Disable DOK if no results available
                $scope.disabledDokList = [];
                angular.forEach($scope.searchData, (dok, dokkey) => {
                    let resultCountInsideDok = 0;

                    angular.forEach($scope.searchData[dokkey], (ell, ellkey) => {
                        resultCountInsideDok += Object.keys($scope.searchData[dokkey][ellkey]).length;
                    });

                    if (resultCountInsideDok < 1) {
                        $scope.disabledDokList.push(dokkey);
                    } else if ($scope.disabledDokList.includes(dokkey)) {
                        $scope.disabledDokList.pop();
                    }
                });

                $scope.isSearchFilteringRunning = false;
                loadLessonPlan();
            }
        }).catch((error) => {
            $log.info(error);
            errorHandler(error);
        });

        return false;
    };

    $scope.determineListClass = (index, isLast, value, isQuestion) => {
        try {
            let isSearchResult = null;

            if (isQuestion) {
                isSearchResult = $scope.searchResultsQuestionIds.includes(value.id);
            } else {
                isSearchResult = $scope.searchResultsSentenceIds.includes(value.id);
            }

            if (isSearchResult) {
                if (index === 0) {
                    return 'divider mdc-list-item search-result-first';
                } if (isLast) {
                    return 'mdc-list-item search-result-last';
                }
                return 'divider mdc-list-item search-result';

            }
            if (!isLast) {
                return 'divider mdc-list-item';
            }
            return 'mdc-list-item';


        } catch (e) {
            $log.info(e);
        }

        return false;
    };

    const resetSearch = () => {
        $scope.searchErrorMessage = '';
        $scope.searchData = null;
        $scope.searchResultsQuestionIds = [];
        $scope.searchResultsSentenceIds = [];
        $scope.disabledDokList = [];
    };

    $scope.clearSearch = () => {
        $scope.searchQuery = '';
        resetSearch();
    };

    $scope.determineDokClass = (dokId, index) => {
        if (index === 0) {
            if ($scope.disabledDokList.includes(dokId)) {
                angular.element(`#dok-popover-${dokId}`).popover({
                    container: 'body',
                    placement: 'top',
                    trigger: 'hover',
                    content: 'No results that match your search'
                });
                return 'mdc-list-item mdc-list-item--selected mdc-list-item--disabled';
            }
            angular.element(`#dok-popover-${dokId}`).popover('dispose');
            return 'mdc-list-item mdc-list-item--selected';

        }
        if ($scope.disabledDokList.includes(dokId)) {
            angular.element(`#dok-popover-${dokId}`).popover({
                container: 'body',
                placement: 'top',
                trigger: 'hover',
                content: 'No results that match your search'
            });
            return 'mdc-list-item mdc-list-item--disabled';
        }
        angular.element(`#dok-popover-${dokId}`).popover('dispose');
        return 'mdc-list-item';
    };

    $scope.handleLanguageChangeEvent = (language) => {
        $scope.isNavCollapseableHidden = false;
        showProgress(true, 'Processing language change...');
        DrawpService.setAddonDefaults(language, false, $scope.initValuePlaceholder, $scope.serverToken);
    };

    $scope.handleDefaultValueEvent = () => {
        DrawpService.setAddonDefaults($scope.language, false, $scope.initValuePlaceholder, $scope.serverToken);
    };

    $scope.handleSelectPairsChangeEvent = () => {
        DrawpService.gAChangeSelectPairsEvent($scope.selectpairs, 6, $scope.subscription, $scope.serverToken);
    };

    $scope.onEnterPressed = (event) => {
        if (event.keyCode === 13) {
            // Cancel the default action, if needed
            event.preventDefault();
            // Trigger the button element with a click
            $scope.searchFunction();
        }
    };

    $scope.reload = () => {
        init();
    };

    $scope.onPurchaseClick = () => {
        if (!DrawpService.isLoggedIn()) {
            $scope.loginDialogMessage = 'Please login to purchase this tool.';
            $scope.isLoginDialogOpen = true;
        } else {
            DrawpService.gAPurchaseButtonSelectedEvent(6, $scope.language, null, null, $scope.serverToken);
            $state.go('payment', {
                tool: "6",
                language: $scope.language,
                data1: null,
                data2: null
            });
        }
    };

    $scope.showSubscriptionDetail = () => {
        showProgress(true, progressText);
        // google.script.run.withSuccessHandler((text) => {
        //     if (!text) {
        //         showError(true, 'There was an error while loading this page');
        //     }
        //     else {
        //         const data = JSON.parse(text);
        //         $scope.is_renew_toggle_available = true;
        //         $scope.cancel_at_period_end = false;
        //         $scope.subscriptionDaysLeft = null;
        //         $scope.subscriptionExpiryDate = null;

        //         if (data.cancel_at_period_end != null) {
        //             $scope.cancel_at_period_end = !data.cancel_at_period_end;
        //         } else {
        //             $scope.is_renew_toggle_available = false;
        //         }

        //         if (data.subscription_due_on != null) {
        //             $scope.subscriptionDaysLeft = data.subscription_days_left;

        //             const date = new Date(data.subscription_due_on.replace(' ', 'T'));
        //             const months = ['Jan', 'Feb', 'Mar', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
        //             const ampm = date.getHours() >= 12 ? 'pm' : 'am';

        //             let minutes = date.getMinutes();
        //             if (minutes < 10) {
        //                 minutes = `0${minutes}`;
        //             }

        //             $timeout(() => {
        //                 $scope.subscriptionExpiryDate = `${months[date.getMonth()]} ${date.getDate().toString()}, ${date.getFullYear().toString()} at ${date.getHours()}:${minutes} ${ampm}`;
        //             });
        //         }

        //         showProgress(false, '');
        //         subscriptionInfoDialog.open();

        //         if ($scope.is_renew_toggle_available) {
        //             elementCancelSub = mdc.switchControl.MDCSwitch.attachTo(document.querySelector('#cancel-subscription-switch'));
        //             elementCancelSub.checked = $scope.cancel_at_period_end;
        //         }
        //     }
        // }).withFailureHandler(errorHandler).getSubscriptionData($scope.toolId, $scope.serverToken);
    };

    $scope.cancel_at_period_end_change = () => {
        // DrawpService.renewSubscriptionToggle(elementCancelSub.checked, $scope.toolId, $scope.serverToken);
    };

    $scope.snackBarUtil = (show, messageText, actionText) => {
        $scope.launchSnackBar(messageText, actionText, show);
    };

    $scope.reloadCurrentPage = () => {
        $state.go($state.current.name, {}, { reload: true });
    };

    $scope.onSlideSelected = (destIndex, totalSlides) => {
        DrawpService.gABasicEvent('select_slide_dialog_selection', {
            username: $scope.userEmail,
            pageName: 'language-scaffolding-tool-6',
            total_slides: totalSlides,
            selected_slide: destIndex + 1
        }, $scope.serverToken);
        insertQuestionSet($scope.slideDialogData.type, $scope.slideDialogData.value, destIndex);
        $scope.hideSelectSlideDialog();
    };
};